// src/Home.js

import React, {Fragment } from 'react';
import { withAuth } from '@okta/okta-react';
import ResizeDetector from 'react-resize-detector';
import {connect} from 'react-redux';
import cx from 'classnames';
import {withRouter} from 'react-router-dom';
import AppMain from '../Layout/AppMain';


class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = { authenticated: null,  closedSmallerSidebar: false };
    this.checkAuthentication = this.checkAuthentication.bind(this);
    this.checkAuthentication();
  }

  async checkAuthentication() {
    const authenticated = await this.props.auth.isAuthenticated();
    if (authenticated !== this.state.authenticated) {
      const userinfo = await this.props.auth.getUser();
      // localStorage.setItem('quserinfo',JSON.stringify(userinfo));
      this.setState({ authenticated });

    }
    if (!authenticated) {
      this.props.history.push('/login');
    }
  }

  componentDidUpdate() {
    this.checkAuthentication();
  }





  render() {
    let {
            colorScheme,
            enableFixedHeader,
            enableFixedSidebar,
            enableFixedFooter,
            enableClosedSidebar,
            closedSmallerSidebar,
            enableMobileMenu,
           
        } = this.props;


    if (this.state.authenticated === null) return null;


    const button = this.state.authenticated ?
      <button onClick={() => {this.props.auth.logout()}}>Logout</button> :
      <button onClick={() => {this.props.auth.login()}}>Login</button>;

    return (
      <div>
      <ResizeDetector
              handleWidth
              render={({ width }) => (
                  <Fragment>
                  <div className={cx(
                      "app-container app-theme-" + colorScheme,
                      {'fixed-header': enableFixedHeader},
                      {'fixed-sidebar': enableFixedSidebar || width < 1250},
                      {'fixed-footer': enableFixedFooter},
                      {'closed-sidebar': enableClosedSidebar || width < 1250},
                      {'closed-sidebar-mobile': closedSmallerSidebar || width < 1250},
                      {'sidebar-mobile-open': enableMobileMenu},
                  )}>
                          {this.state.authenticated ?
                            <AppMain/>  : button }
                      </div>
                  </Fragment>
                )}
        />
      </div>
    );
  }
}

const mapStateToProp = state => ({
    colorScheme: state.ThemeOptions.colorScheme,
    enableFixedHeader: state.ThemeOptions.enableFixedHeader,
    enableMobileMenu: state.ThemeOptions.enableMobileMenu,
    enableFixedFooter: state.ThemeOptions.enableFixedFooter,
    enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
    enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,

});

export default withRouter(withAuth(connect(mapStateToProp)(Home)));
